module.exports = __webpack_public_path__ + "img/FR.08c52dda.svg";